import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaContactTypes } from './sagaContactRedux';
import { push } from 'react-router-redux';
import { buildUrl, getSagaWAPUrl, getCurrentUserId } from '../../helpers/utility';
import IDeedDetailUpdate from '../sagaDeed/IDeedDetailUpdate';
import { Result } from '../helpers/Ihelper';


export const currentLanguageRfc3066Fnc = (state) => state.Language.language.rfc3066;

export function* requestGetContacts(action) {
    const tag = '[REQUEST_GET_CONTACTS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetContacts, jwtToken, branchId, culture, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetContacts response :`, response.data);
                yield put(Actions.getContactsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetContacts failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getContactsFailure(message));
    }
}

export function* requestUpdateContactBatch(action) {
    const tag = '[REQUEST_UPDATE_CONTACT_BATCH]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateContactBatch, jwtToken, branchId, culture, action.contactBatchData);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateContactBatch response :`, response.data);
                yield put(Actions.updateContactBatchSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateContactBatch failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateContactBatchFailure(message));
    }
}


export function* requestGetContactDetail(action) {
    const tag = '[REQUEST_GET_CONTACT_DETAIL]';
    try {

        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            const response = yield call(API.requestGetContactDetail, jwtToken, branchId, culture, action.contactId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetContactDetail response :`, response.data);
                yield put(Actions.getContactDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetContactDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getContactDetailFailure(message));
    }
}

export function* requestUpdateContactDetail(action) {
    const tag = '[REQUEST_UPDATE_CONTACT_DETAIL]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            const response = yield call(API.requestUpdateContactDetail, jwtToken, action.contact, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateContactDetail response :`, response.data);
                yield put(Actions.updateContactDetailSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/account/contact/${response.data.result}`)));

            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateContactDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateContactDetailFailure(message));
    }
}

export function* requestRemoveContactDetail(action) {
    const tag = '[REQUEST_REMOVE_CONTACT_DETAIL]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            const response = yield call(API.requestRemoveContactDetail, jwtToken, action.contactId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemoveContactDetail response :`, response.data);
                yield put(Actions.removeContactDetailSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/account/contact`)));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemoveContactDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removeContactDetailFailure(message));
    }
}

export function* requestGenerateContactReport(action) {
    const tag = '[REQUEST_GENERATE_CONTACT_REPORT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateContactReport, jwtToken, branchId, culture, action.contactIds, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGenerateContactReport response :`, response.data);
                window.open(response.data.result, '_blank');
                yield put(Actions.generateContactReportSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGenerateContactReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateContactReportFailure(message));
    }
}

export function* requestGetContactProperties(action) {
    const tag = '[REQUEST_GET_CONTACT_PROPERTIES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetContactProperties, jwtToken, branchId, culture, action.contactId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetContactProperties response :`, response.data);
                yield put(Actions.getContactPropertiesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetContactProperties failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getContactPropertiesFailure(message));
    }
}

export function * requestGetContactRelatedProperties(action) {
    const tag = '[REQUEST_GET_CONTACT_RELATED_PROPERTIES]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
          const response = yield call(API.requestGetContactRelatedProperties, jwtToken, branchId, culture, action.contactId);
          if (response.status === 200 && response.data.statusCode === 200) {
              console.log(`${tag} requestGetContactRelatedProperties response :` , response.data);
              yield put(Actions.getContactRelatedPropertiesSuccess(response.data.result));
          } else {
              throw new Error(response.data.error);
          }
  
      } else {
          throw new Error('xx.yyInvalidInput'); // <-- fix me
      } 
    }
    catch (e) {
      console.warn(`${tag} requestGetContactRelatedProperties failed with error :` , e);
      const message = e.message ? e.message : 'Failed';
      yield put(Actions.getContactRelatedPropertiesFailure(message));
    }
  }


  export function * requestDeleteContacts(action) {
    const tag = '[REQUEST_DELETE_CONTACTS]';
    try {
        const jwtToken = yield getJwtToken(); 
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const userId = yield getCurrentUserId();
        if (jwtToken) {
          const response = yield call(API.requestDeleteContacts,jwtToken,branchId,userId,culture,action.contactIds);
          if (response.status === 200 && response.data.statusCode === 200) {
              console.log(`${tag} requestDeleteContacts response :` , response.data);
              yield put(Actions.deleteContactsSuccess(response.data.result));
          } else {
              throw new Error(response.data.error);
          }
  
      } else {
          throw new Error('xx.yyInvalidInput'); // <-- fix me
      } 
    }
    catch (e) {
      console.warn(`${tag} requestDeleteContacts failed with error :` , e);
      const message = e.message ? e.message : 'Failed';
      yield put(Actions.deleteContactsFailure(message));
    }
  }


export default function* rootSaga() {
    yield all([
        takeLatest(SagaContactTypes.REQUEST_GET_CONTACTS, requestGetContacts),
        takeLatest(SagaContactTypes.REQUEST_UPDATE_CONTACT_BATCH, requestUpdateContactBatch),
        takeLatest(SagaContactTypes.REQUEST_GET_CONTACT_DETAIL, requestGetContactDetail),
        takeLatest(SagaContactTypes.REQUEST_UPDATE_CONTACT_DETAIL, requestUpdateContactDetail),
        takeLatest(SagaContactTypes.REQUEST_REMOVE_CONTACT_DETAIL, requestRemoveContactDetail),
        takeLatest(SagaContactTypes.REQUEST_GENERATE_CONTACT_REPORT, requestGenerateContactReport),
        takeLatest(SagaContactTypes.REQUEST_GET_CONTACT_PROPERTIES, requestGetContactProperties),
        takeLatest(SagaContactTypes.REQUEST_GET_CONTACT_RELATED_PROPERTIES, requestGetContactRelatedProperties),
        takeLatest(SagaContactTypes.REQUEST_DELETE_CONTACTS, requestDeleteContacts),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagaContact/sagaContactSaga.ts